import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../utils/firebase/firebase';

export const fetchSessionNotes = async (
  uid,
  typeOfUser,
  studentId,
  options = {}
) => {
  try {
    const getSessionNotes = httpsCallable(CloudFunctions, 'getSessionNotes');

    const response = await getSessionNotes({
      uid,
      typeOfUser,
      studentId,
      limit: options.limit || 50,
      startAfter: options.startAfter || null,
      startDate: options.startDate || null,
      endDate: options.endDate || null,
    });

    if (response?.data?.status) {
      return {
        success: true,
        sessionNotes: response.data.sessionNotes || [],
        hasMore: response.data.hasMore || false,
        lastDoc: response.data.lastDoc || null,
        message: response.data.message || 'Session notes fetched successfully',
      };
    } else {
      console.warn(
        'fetchSessionNotes: API returned false status',
        response.data?.message
      );
      return {
        success: false,
        sessionNotes: [],
        hasMore: false,
        lastDoc: null,
        message: response.data?.message || 'Failed to fetch session notes',
      };
    }
  } catch (error) {
    console.error('Error in fetchSessionNotes:', error);
    return {
      success: false,
      sessionNotes: [],
      hasMore: false,
      lastDoc: null,
      message: 'Error fetching session notes',
    };
  }
};

export const updateSessionNote = async (
  uid,
  typeOfUser,
  studentId,
  sessionNoteId,
  infoValue
) => {
  try {
    const updateSessionNoteFunc = httpsCallable(
      CloudFunctions,
      'updateSessionNote'
    );

    const response = await updateSessionNoteFunc({
      uid,
      typeOfUser,
      studentId,
      sessionNoteId,
      infoValue,
    });

    if (response?.data?.status) {
      return {
        success: true,
        message: response.data.message || 'Session note updated successfully',
      };
    } else {
      console.warn(
        'updateSessionNote: API returned false status',
        response.data?.message
      );
      return {
        success: false,
        message: response.data?.message || 'Failed to update session note',
      };
    }
  } catch (error) {
    console.error('Error in updateSessionNote:', error);
    return {
      success: false,
      message: 'Error updating session note',
    };
  }
};
